import React, { useCallback } from 'react';
import { isTablet } from 'react-device-detect';
import { PreviewModeProps } from '../../../model/types';
import { TransformedImage } from '../../TransformedImage';
import { useImageState } from '../../../hooks/useImageState';
import { ModsToolbar } from '../../ModsToolbar';
import { BackButton } from '../../BackButton';
import { useImageContainer } from '../../../hooks/useImageContainer';
import { CloseButton } from '@view/components';
import { Sidebar } from '@view/layouts';
import { cn } from '@utils';
import styles from './styles.scss';

const PreviewMode = ({
  isPreviewModeOpen,
  onPreviewModeClose,
  url,
  defaultImageState,
}: PreviewModeProps) => {
  const { imageState, handleToggleModeValue, handleChangeModeValue } =
    useImageState(defaultImageState);

  const { image, containerRef, containerSize } = useImageContainer(url);

  const renderDescription = useCallback(() => {
    return [
      imageState.isFlipped && 'Image flipped horizontally',
      imageState.zoom !== 1 && `Zoom ${imageState.zoom * 100}%`,
    ]
      .filter(Boolean)
      .join(', ');
  }, [imageState.isFlipped, imageState.zoom]);

  return (
    <Sidebar size="lg" isOpen={isPreviewModeOpen}>
      <div className={styles.previewMode_header}>
        <BackButton onClick={onPreviewModeClose} />
        <ModsToolbar
          imageState={imageState}
          onToggleMode={handleToggleModeValue}
          onChangeMode={handleChangeModeValue}
        />
        <CloseButton
          className={cn('opacity-0 pointer-events-none lg:opacity-100 lg:pointer-events-auto', isTablet && 'hidden')}
          size="lg"
          onClick={onPreviewModeClose}
        />
      </div>
      <div ref={containerRef} className={styles.previewMode_photoWrapper}>
        <TransformedImage
          image={image}
          containerSize={containerSize}
          modifications={imageState}
        />
      </div>
      <div className={styles.previewMode_previewChangeLabel}>
        {renderDescription()}
      </div>
    </Sidebar>
  );
};

export default PreviewMode;
